import { __assign } from "tslib";
import React from 'react';
import { Platform, Text, View } from "react-native";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { HtmlToNativeNative, PnmacText } from "pnmac-universal-components";
import moment from "moment";
import ExpanderComponent from "./ExpanderComponent";
var AntDesign = function () {
  return /*#__PURE__*/React.createElement(View, null);
};
if (Platform.OS !== "web") {
  try {
    AntDesign = require("react-native-vector-icons/AntDesign").default;
  } catch (error) {}
}
function CompletedTable(props) {
  var _a;
  var translations = props.translations,
    layout = props.layout;
  var completed = (_a = props.modifications) === null || _a === void 0 ? void 0 : _a.completedConditions.find(function (c) {
    return c;
  });
  if (!completed) {
    return /*#__PURE__*/React.createElement(Text, null, translations.NoCompletedItems);
  }
  var tableCompleteContent = [{
    view: /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(CheckBoxIcon, null)),
    flex: 1
  }, {
    view: /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
      id: "completedCondtionDescription",
      style: {
        alignItems: "flex-start",
        marginHorizontal: 5
      }
    }, !completed.detailedExplanation || completed.detailedExplanation === "" ? /*#__PURE__*/React.createElement(View, null, layout.language == "en" ? /*#__PURE__*/React.createElement(HtmlToNativeNative, {
      value: completed.conditionDescription,
      navigation: props.navigation
    }) : /*#__PURE__*/React.createElement(HtmlToNativeNative, {
      value: completed.spanishConditionDescription,
      navigation: props.navigation
    })) : /*#__PURE__*/React.createElement(Text, {
      style: textStyle.defaultTextDescription
    }, completed.DetailedExplanation), !!completed.note && /*#__PURE__*/React.createElement(HtmlToNativeNative, {
      value: completed.note,
      navigation: props.navigation
    }))),
    flex: 3
  }, {
    title: translations.CompletionDate,
    view: /*#__PURE__*/React.createElement(Text, {
      style: textStyle.defaultTextDescription,
      id: "completeddate"
    }, !!completed.completedDate ? moment(completed.completedDate).format("MM/DD/YYYY") : translations.NotApplicable),
    flex: 1
  }, {
    title: "Uploaded documents",
    view: /*#__PURE__*/React.createElement(ExpanderComponent, __assign({}, props, completed)),
    flex: 1
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
    style: {
      flexDirection: 'row'
    }
  }, [{
    title: translations.MiscDocUploadHeader,
    flex: 1
  }, {
    title: translations.ModDescription,
    flex: 3
  }, {
    title: translations.CompletionDate,
    flex: 1
  }, {
    title: "Uploaded documents",
    flex: 1
  }].map(function (item, index) {
    return /*#__PURE__*/React.createElement(View, {
      key: String(index),
      style: {
        flex: item.flex,
        marginRight: 10
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign({
        marginTop: 20
      }, textStyle.defaultTextTitle)
    }, item.title));
  })), /*#__PURE__*/React.createElement(View, {
    style: {
      marginRight: 10,
      flexDirection: 'row'
    }
  }, tableCompleteContent.map(function (item, index) {
    return /*#__PURE__*/React.createElement(View, {
      style: {
        flex: item.flex,
        marginTop: 10
      },
      key: String(index)
    }, item.view);
  })));
}
export default CompletedTable;